import { orpc } from 'src/api/rpc/client';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/context/ToastContext';

export function useListVoiceAgentConfigs() {
  return useQuery(
    orpc.integrations.voiceAgentConfigs.list.queryOptions({ input: {} }),
  );
}

export function useCreateVoiceAgentConfig() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation(
    orpc.integrations.voiceAgentConfigs.create.mutationOptions({
      onSuccess: () => {
        showToast({
          title: 'Configuration created',
          message: 'Voice agent configuration created successfully.',
          color: 'success',
        });
        queryClient.invalidateQueries({
          queryKey: orpc.integrations.voiceAgentConfigs.list.key(),
        });
      },
      onError: (error) => {
        showToast({
          title: 'Could not create configuration',
          message:
            error.message || 'An unexpected error occurred. Please try again.',
          color: 'error',
        });
      },
    }),
  );
}

export function useUpdateVoiceAgentConfig() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation(
    orpc.integrations.voiceAgentConfigs.update.mutationOptions({
      onSuccess: () => {
        showToast({
          title: 'Configuration updated',
          message: 'Voice agent configuration updated successfully.',
          color: 'success',
        });
        queryClient.invalidateQueries({
          queryKey: orpc.integrations.voiceAgentConfigs.list.key(),
        });
      },
      onError: (error) => {
        showToast({
          title: 'Could not update configuration',
          message:
            error.message || 'An unexpected error occurred. Please try again.',
          color: 'error',
        });
      },
    }),
  );
}

export function useDeleteVoiceAgentConfig() {
  const queryClient = useQueryClient();
  const { showToast } = useToast();
  return useMutation(
    orpc.integrations.voiceAgentConfigs.delete.mutationOptions({
      onSuccess: () => {
        showToast({
          title: 'Configuration deleted',
          message: 'Voice agent configuration deleted successfully.',
          color: 'success',
        });
        queryClient.invalidateQueries({
          queryKey: orpc.integrations.voiceAgentConfigs.list.key(),
        });
      },
      onError: (error) => {
        showToast({
          title: 'Could not delete configuration',
          message:
            error.message || 'An unexpected error occurred. Please try again.',
          color: 'error',
        });
      },
    }),
  );
}
